<template>
  <mdb-container>
    <banner-small :group="group" title="My Answers/Acknowledgements" v-if="group"/>
    <mdb-card class="mb-4">
      <mdb-card-body>
        <answers :hide-cancel="true" :group="group" :subscriptions="false" @submit="submittedAnswers" v-if="group"></answers>
      </mdb-card-body>
    </mdb-card>
  </mdb-container>
</template>

<script>
import Answers from "./Answers";
import {mdbCard, mdbCardBody, mdbContainer} from 'mdbvue';
import BannerSmall from "./BannerSmall"
import {mapState} from "vuex";
import api from "../../services/groupsPlaceApi";

export default {
    name: 'Group-Answers',
    components: {
      BannerSmall,
      mdbContainer,
      mdbCard,
      mdbCardBody,
      Answers
    },
    data() {
      return {
        //details: { balance: null, transactions:[], allowStripe: false, groupId: null }
        details: null,
        complete: false,
        stripeOptions: {
          requestPayerName: true,
          requestPayerEmail: true
        }
      }
    },
    computed: mapState({
                         group: state => state.currentGroup,
                         userDetails: state => state.userDetails
                       }),
    async mounted() {
      await this.$store.dispatch("setExecuting", true);
      await api.groupBasics(this.$route.params.id, "member");
    },
    methods: {
      submittedAnswers(data) {
        this.$store.dispatch("setExecuting", true)
        api.post("/member/answers/" + this.group.vanityPath, {questions: data}).then(
          (details) => {
            this.$notify.success({message: "Saved!", timeOut: 2000})
          },
          (error) => {
            this.$notify.error({message: "Could not post answers at this time.", timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      },
    }
  }

</script>
